var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseFill = function SvgCloseFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    transform: "rotate(90)",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#036",
    fillRule: "evenodd",
    d: "M15.874 8.016A7.859 7.859 0 1 1 .157 8.015a7.859 7.859 0 0 1 15.717.001M5.634 5.635a.59.59 0 0 1 .833 0l1.548 1.548 1.548-1.548a.59.59 0 0 1 .834.834L8.849 8.017l1.548 1.548a.59.59 0 0 1-.833.833L8.016 8.85l-1.548 1.548a.589.589 0 1 1-.833-.833l1.548-1.548-1.548-1.548a.59.59 0 0 1 0-.833",
    clipRule: "evenodd"
  })));
};
export default SvgCloseFill;